import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { fetchLikedArticles, fetchMyLikedUserArticles, fetchUserProfile } from '../../services/api';
import Sidebar from './Sidebar'; // Import the Sidebar component

const DEFAULT_FEATURED_IMAGE =
    'https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736181865/web_development___website_webpage_browser_ad_advertisement_man_people_ibpgaq.png';

const getCloudinaryUrl = (img) => {
    if (!img) return DEFAULT_FEATURED_IMAGE;
    // If img already contains 'image/upload/', just prepend the base Cloudinary URL
    if (img.includes('image/upload/')) {
        return `https://res.cloudinary.com/dbm8xbouw/${img}`;
    }
    // Otherwise, assume it's just an ID and prepend the standard path
    return `https://res.cloudinary.com/dbm8xbouw/image/upload/${img}`;
};


const Bookmarks = () => {
    const [likedArticles, setLikedArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [userProfile, setUserProfile] = useState(null);

    const [sidebarCollapsed, setSidebarCollapsed] = useState(
        () => JSON.parse(localStorage.getItem('sidebarCollapsed')) || false
    );

    useEffect(() => {
        localStorage.setItem('sidebarCollapsed', JSON.stringify(sidebarCollapsed));
    }, [sidebarCollapsed]);

    const navigate = useNavigate();
    const token = localStorage.getItem('authToken');
    const location = useLocation();

    useEffect(() => {
        const fetchArticles = async () => {
    setLoading(true);
    try {
        const [myPublishedLikes, userSubmittedLikes] = await Promise.all([
            fetchLikedArticles(),            // liked articles I published
            fetchMyLikedUserArticles(token)  // liked articles by other users
        ]);

        // Merge the two arrays
        const merged = [...myPublishedLikes, ...userSubmittedLikes];

        // Optional: sort by creation date descending
        merged.sort((a, b) => new Date(b.created_on) - new Date(a.created_on));

        setLikedArticles(merged);
    } catch (err) {
        setError('Failed to load liked articles. Please try again.');
        console.error(err);
    } finally {
        setLoading(false);
    }
};


        const loadUserProfile = async () => {
            try {
                const profileData = await fetchUserProfile(token);
                setUserProfile(profileData);
            } catch (err) {
                console.error('Error fetching user profile:', err);
            }
        };

        fetchArticles();
        loadUserProfile();
    }, [token]);

    const handleLogout = () => {
        navigate('/logout');
    };

    return (
        <div className="dashboard-background">
            <div className="container-fluid">
                {error && <div style={{ color: 'red' }}>{error}</div>}
                <div className="d-flex">
                    {/* Sidebar */}
                    <Sidebar userProfile={userProfile}
                        isCollapsed={sidebarCollapsed}
                        setIsCollapsed={setSidebarCollapsed}
                    />

                    {/* Main Content */}
                    <main className="flex-grow-1 px-4"
                        style={{
                            minHeight: '80vh',
                            marginLeft: sidebarCollapsed ? '60px' : '220px'
                        }}>
                        <div className="text-center mb-4">
                            <img
                                src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736174973/image-removebg-preview_1_rez4gn.png"
                                alt="Logo"
                                style={{ width: '100px', height: '100px', marginRight: '0px' }}
                            />
                            <h1 className="fw-bold d-inline mb-0">Saved Articles</h1>
                        </div>

                        <div className="container mt-1">
                            <div className="d-flex justify-content-center">
                                <div className="list-group" style={{ width: '75%' }}>
                                    {loading ? (
                                        <p>Loading liked articles...</p>
                                    ) : (
                                        <div>
                                            {likedArticles.length === 0 ? (
                                                <div className="row">
                                                    <div className="col-md-6 d-flex flex-column align-items-center justify-content-center">
                                                        <h1 className="text-center mb-5 fw-bold">Looks like you haven’t saved anything yet.</h1>
                                                        <h5 className="text-center mb-3">Found a post you love?  Hit the like button and it’ll appear here.</h5>
                                                        <h5 className="text-center">Don’t like it anymore? Un-Like it and let it wander back into the wild.</h5>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <img
                                                            src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736181865/web_development___website_webpage_browser_ad_advertisement_man_people_ibpgaq.png"
                                                            alt="No articles"
                                                            className="img-fluid"
                                                            style={{ maxWidth: '100%', height: 'auto' }}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                likedArticles.map((article) => (
                                                    <a
                                                        key={article.id}
                                                        href={article.is_user_submitted ? `/user-posts/${article.slug}` : `/posts/${article.slug}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="list-group-item list-group-item-action d-flex align-items-center mb-4"
                                                        style={{ transition: 'background-color 0.3s ease', width: '100%' }}
                                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#E5E7EB'}
                                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = ''}
                                                    >
                                                        <img
                                                            src={getCloudinaryUrl(article.featured_image)}
                                                            alt={article.title}
                                                            className="img-thumbnail me-3"
                                                            style={{ width: '150px', height: 'auto', objectFit: 'cover' }}
                                                            onError={(e) => { e.currentTarget.src = DEFAULT_FEATURED_IMAGE; }}
                                                        />

                                                        <div>
                                                            <h5 className="mb-1">{article.title}</h5>
                                                            <p className="mb-1 text-muted">{article.excerpt || 'No description available'}</p>
                                                        </div>
                                                    </a>

                                                ))
                                                )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Bookmarks;


